import { ResourceCentrePageCategory } from '../../../types';
import { translations as healthCard } from './health-card';
import { translations as driversLicence } from './licence';
import { translations as paymentCards } from './payment-cards';
import { translations as rewardCards } from './reward-cards';
import { translations as serviceCards } from './service-cards';
import { translations as sinCard } from './sin-card';

export const translations: ResourceCentrePageCategory = {
  // tslint:disable-next-line:quotemark
  title: "Récupération d'objets perdus ou volés",
  items: {
    paymentCards,
    driversLicence,
    healthCard,
    serviceCards,
    sinCard,
    rewardCards
  }
};
